export interface RelatorioExtratoCartao {
    data: string,
    placa: string,
    posto: string,
    nomeDoPosto: string,
    combustivel: string,
    volume: number,
    precoUnitario: number,
    valor: number,
    odoHora: number,
    solicitante: string,
    aprovador: string
}




export interface IRelatorioExtratoCartao {
    retorno: RelatorioExtratoCartao[],
    sucesso: boolean,
    mensagens: string[]
}
